import { Trans } from 'react-i18next';

import { BlueContainer, Paragraph } from '@app/shared/ui/atoms/Common';

export function Description() {
  return (
    <BlueContainer className="mt-6">
      <Paragraph className="font-normal text-card-foreground">
        <Trans i18nKey="daily_card_description.description" components={{ 1: <b />, 2: <br /> }} />
      </Paragraph>
    </BlueContainer>
  );
}
